import { render } from "./NetworkPayors.vue?vue&type=template&id=2707df72&scoped=true"
import script from "./NetworkPayors.vue?vue&type=script&lang=js"
export * from "./NetworkPayors.vue?vue&type=script&lang=js"

import "./NetworkPayors.vue?vue&type=style&index=0&id=2707df72&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2707df72"],['__file',"src/views/labs/NetworkPayors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2707df72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2707df72', __exports__)) {
    console.log('reload')
    api.reload('2707df72', __exports__)
  }
  
  module.hot.accept("./NetworkPayors.vue?vue&type=template&id=2707df72&scoped=true", () => {
    console.log('re-render')
    api.rerender('2707df72', render)
  })

}


export default __exports__